import React from "react";

export const priorityOptions = [
  { value: 1, label: "High" },
  { value: 2, label: "Medium" },
  { value: 3, label: "Low" },
];

export const priorityTextToNumber = (priorityInput) => {
  if (!priorityInput) return 2;

  const priorityMap = {
    High: 1,
    Medium: 2,
    Low: 3,
    high: 1,
    medium: 2,
    low: 3,
    1: 1,
    2: 2,
    3: 3,
  };

  return priorityMap[priorityInput] || 2;
};

export const getPriorityInfo = (priority) => {
  const priorityNum = priorityTextToNumber(priority);
  switch (priorityNum) {
    case 1:
      return {
        color: "bg-red-100 text-red-800 border-red-200",
        text: "High",
      };
    case 2:
      return {
        color: "bg-yellow-100 text-yellow-800 border-yellow-200",
        text: "Medium",
      };
    case 3:
      return {
        color: "bg-green-100 text-green-800 border-green-200",
        text: "Low",
      };
    default:
      return {
        color: "bg-gray-100 text-gray-800 border-gray-200",
        text: "Medium",
      };
  }
};

export const statusTextToNumber = (statusText) => {
  const statusMap = {
    New: 1, new: 1,
    "In Progress": 2, Inprogress: 2, inprogress: 2, "in progress": 2,
    Closed: 3, closed: 3,
    Blocked: 4, blocked: 4,
    "On Hold": 5, "on hold": 5, OnHold: 5, onhold: 5,
    Resolved: 6, resolved: 6,
    1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6,
  };
  return statusMap[statusText] ?? 0;
};

export const statusNumberToText = (statusNumber) => {
  const statusMap = {
    1: "New",
    2: "In Progress",
    3: "Closed",
    4: "Blocked",
    5: "On Hold",
    6: "Resolved",
    0: "New",
  };
  return statusMap[statusNumber] ?? "Unknown";
};

export const getStatusBadge = (status) => {
  const statusNum = statusTextToNumber(status);
  const config = {
    1: { label: "New",         cls: "bg-purple-100 text-purple-800 border-purple-200" },
    2: { label: "In Progress", cls: "bg-blue-100 text-blue-800 border-blue-200" },
    3: { label: "Closed",      cls: "bg-green-100 text-green-800 border-green-200" },
    4: { label: "Blocked",     cls: "bg-red-100 text-red-800 border-red-200" },
    5: { label: "On Hold",     cls: "bg-yellow-100 text-yellow-800 border-yellow-200" },
    6: { label: "Resolved",    cls: "bg-teal-100 text-teal-800 border-teal-200" },
  };
  const { label, cls } = config[statusNum] ?? { label: "Unknown", cls: "bg-gray-100 text-gray-800 border-gray-200" };
  return (
    <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium border ${cls}`}>
      {label}
    </span>
  );
};
export const getTeamMemberName = (task, usersList) => {
  if (task.assignedTo && typeof task.assignedTo === "string") {
    return task.assignedTo;
  }
  const user = usersList.find((user) => user.id === task.assignedToId);
  return user
    ? `${user.first_name} ${user.last_name}`
    : task.assignedTo || "Unknown Member";
};

export const getAssignedByName = (task, usersList) => {
  if (task.assignedBy && typeof task.assignedBy === "string") {
    return task.assignedBy;
  }
  const user = usersList.find((user) => user.id === task.assignedById);
  return user ? `${user.first_name} ${user.last_name}` : "Unknown";
};

export const getCommenterName = (comment, usersList) => {
  try {
    let user = usersList.find((u) => u.id === comment.userId);

    if (!user && comment.userId) {
      user = usersList.find((u) =>
        u.userprincipal === comment.userId ||
        u.email === comment.userId
      );
    }

    if (user) {
      return `${user.first_name} ${user.last_name}`;
    }

    if (comment.userId?.includes('@')) {
      return comment.userId.split('@')[0];
    }

    return "Unknown User";
  } catch (error) {
    console.error("Error getting commenter name:", error);
    return "Unknown User";
  }
};
